export enum ClientTypeEnum {
  RBLA_COMMON = "RBLA_COMMON",
  RBLA_CAR_RENTAL = "RBLA_CAR_RENTAL",
  DEFAULT = "DEFAULT",
  DAHRUJ = "DAHRUJ",
  SEM_PARAR = "SEM_PARAR"
}
